type AttachmentLike = {
  file_url?: string;
  url?: string;
  file?: string;
  file_path?: string;
};

function resolveApiOrigin(): string {
  // 必须直接写 process.env.REACT_APP_xxx：CRA 构建时只会替换这种字面写法，
  // 用 (process as any)?.env 绕一下的话，浏览器里 process 未定义会直接报错
  const fromEnv = String(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || '').trim();
  if (/^https?:\/\//i.test(fromEnv)) {
    try {
      const u = new URL(fromEnv);
      return `${u.protocol}//${u.host}`;
    } catch {}
  }

  let origin = window.location.origin;
  try {
    const u = new URL(origin);
    if (u.port === '3000') {
      u.port = '8000';
      origin = u.toString().replace(/\/$/, '');
    }
  } catch {}
  return origin;
}

function toAbsoluteUrl(raw: string): string {
  const trimmed = String(raw || '').trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const u = new URL(trimmed);
      const isHttpsPage = window.location.protocol === 'https:';
      const apiHost = new URL(resolveApiOrigin()).host;
      const isTrustedApiHost = u.host === apiHost || /(^|\.)anfeihub\.com$/i.test(u.hostname);
      if (isHttpsPage && u.protocol === 'http:' && isTrustedApiHost) {
        u.protocol = 'https:';
      }
      return u.toString();
    } catch {
      return trimmed;
    }
  }

  let path = trimmed;
  if (!path.startsWith('/')) path = '/' + path;
  if (/^\/(instruction|attachment-templates|attachments?)/i.test(path)) path = '/media' + path;
  if (!/^\/media\//i.test(path)) path = '/media' + path;

  return `${resolveApiOrigin()}${path}`;
}

export function getAttachmentUrl(att: AttachmentLike | null | undefined): string {
  const raw =
    String(att?.file_url || '').trim() ||
    String(att?.url || '').trim() ||
    String(att?.file || '').trim() ||
    String(att?.file_path || '').trim();
  return toAbsoluteUrl(raw);
}

